import { RowCrudStatus } from "../../common/types";
import { CreditMovement } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { CreditMovementType as CreditMovementTypeEnum } from "../../../api/graphql";
import { creditPurchaseDisplayId } from "../../creditPurchase/store/CreditPurchaseCommonStore";

export type CreditMovementValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  type: CreditMovementTypeEnum;
  delta: number;
  balanceAfter: number;
  movementAt: Date | null;
  detail: string;
  editionKey: string;
  editionName: string;
  __purchase: string;
  showPurchase: { displayId: string; id: string } | null;
};

export type CreditMovementErrorsType = {
  type?: { message: string; fieldLabel: string };
  delta?: { message: string; fieldLabel: string };
  balanceAfter?: { message: string; fieldLabel: string };
  movementAt?: { message: string; fieldLabel: string };
  detail?: { message: string; fieldLabel: string };
  editionKey?: { message: string; fieldLabel: string };
  editionName?: { message: string; fieldLabel: string };
  purchase?: { message: string; fieldLabel: string };
};

export function CreditMovementValuesInit(): CreditMovementValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    type: "" as CreditMovementTypeEnum,
    delta: 0,
    balanceAfter: 0,
    movementAt: null,
    detail: "",
    editionKey: "",
    editionName: "",
    __purchase: "",
    showPurchase: null,
  };
}

export type CreditMovementType = CreditMovement | CreditMovementValuesType;

export function creditMovementDisplayId(
  source: Partial<CreditMovement>,
  _langStore: LangStore
) {
  return source.detail ?? _langStore.emptyStringSymbol;
}

export function getCreditMovementValues(
  source: CreditMovementType,
  _langStore: LangStore,
  _duplicated: boolean = false
): CreditMovementValuesType {
  const entityValues = CreditMovementValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : creditMovementDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.type = source.type;
  entityValues.delta = source.delta || 0;
  entityValues.balanceAfter = source.balanceAfter || 0;
  entityValues.movementAt = new Date(source.movementAt);
  entityValues.detail = source.detail;
  entityValues.editionKey = source.editionKey || "";
  entityValues.editionName = source.editionName || "";
  entityValues.showPurchase =
    "purchase" in source && source.purchase
      ? {
          id: source.purchase.id,
          displayId: creditPurchaseDisplayId(source.purchase, _langStore),
        }
      : "showPurchase" in source && source.showPurchase
      ? { id: source.showPurchase.id, displayId: source.showPurchase.displayId }
      : null;
  entityValues.__purchase = entityValues.showPurchase?.displayId || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
